module.exports = __webpack_public_path__ + "f45e559447a0cd900eed5e8b38931c7a.jpg";